import React from 'react';
import { Flex, Row, Skeleton } from 'antd';
import { HomeOutlined, ShoppingOutlined, ShopOutlined, TeamOutlined, ApiOutlined, ScanOutlined, ShareAltOutlined,
  BarChartOutlined, SolutionOutlined, GiftOutlined, PartitionOutlined, ShoppingCartOutlined, FileImageOutlined
} from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import Can from '../../components/ability';
import { sendUserLoginToApp } from '../../utils/app-bridge';
import { SafeStorage, detectWebView } from '../../utils/webview';
import TopSeller from '../chart/topSeller';

const { isWebView } = detectWebView();

const iconStyle = {
  fontSize: 28,
}

const Index = () => {
  const [loading, setLoading] = React.useState(true);
  const [hasAbility, setHasAbility] = React.useState(false);

  React.useEffect(() => {
    const checkUserAbility = async () => {
      try {
        let userAbility = await SafeStorage.getItem('user-ability', true);
        if (userAbility) {
          setHasAbility(true);
        }
      } catch (e) {
        console.error('Failed to get user ability:', e);
      } finally {
        setLoading(false);
      }
    };

    checkUserAbility();
  }, []);

  React.useEffect(() => {
    // 获取设备信息
    sendUserLoginToApp({
        userId: window.__baseInfo.userId,
    });
  })


  if (loading) {
    return <Skeleton active />;
  }

  if (!hasAbility) {
    return <div>暂无权限</div>;
  }

  return (
    <div>
      {/* <div style={{ height: '200px'}}><TopSeller /></div> */}
      {/* <PWAInstall /> */}
      <Row gap={20} style={{ margin: '10px 0 0 0' }}>
        <Can action="read" subject="shop">
          <NavItem href="/shop" text="店铺管理">
            <HomeOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="mall">
          <NavItem href="/mall" text="商城设置">
            <ShopOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="goods">
          <NavItem href="/goods" text="商品管理">
            <ShoppingOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="order">
          <NavItem href="/order" text="订单管理">
            <ShoppingCartOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="customer">
          <NavItem href="/customer" text="客户管理">
            <SolutionOutlined style={iconStyle} />
          </NavItem>
        </Can>
        

        <Can action="read" subject="shop">
          <NavItem href="/salesnet" text="联盟">
            <PartitionOutlined style={iconStyle} />
          </NavItem>
        </Can>
        

        <Can action="read" subject="promotion">
          <NavItem href="/promotion" text="促销管理">
            <GiftOutlined style={iconStyle} />
          </NavItem>
        </Can>
        
        {window.__baseInfo.versionId !== 1 && <Can action="read" subject="channel">
          <NavItem href="/channel" text="经营渠道">
            <ApiOutlined style={iconStyle} />
          </NavItem>
        </Can>}

        <Can action="read" subject="account">
          <NavItem href="/account" text="账号管理">
            <TeamOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="finance">
          <NavItem href="/finance" text="财务对账">
            <BarChartOutlined style={iconStyle} />
          </NavItem>
        </Can>

        {window.__baseInfo.versionId !== 1 && <Can action="read" subject="mall">
          <NavItem href="/album" text="素材中心">
            <FileImageOutlined style={iconStyle} />
          </NavItem>
        </Can>}

        <Can action="read" subject="order">
          <NavItem href="/writeoff" text="核销">
            <ScanOutlined style={iconStyle} />
          </NavItem>
        </Can>

        <Can action="read" subject="order">
          <NavItem href="/join" text="邀请(获得佣金)">
            <ShareAltOutlined style={iconStyle} />
          </NavItem>
        </Can>
      </Row>
    </div>
  )
}

export default Index;